import { motion } from 'framer-motion';
import { EXPERIENCE } from '../data';

export default function Experience() {
  return (
    <section id="experience" className="section-pad relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-indigo-950/8 to-transparent pointer-events-none" />
      <div className="max-w-4xl mx-auto px-6">

        {/* Header */}
        <motion.div initial={{opacity:0,y:28}} whileInView={{opacity:1,y:0}}
          transition={{duration:0.55}} viewport={{once:true}} className="text-center mb-20">
          <p className="text-violet-400 font-mono text-xs tracking-[0.2em] uppercase mb-4">— Work Experience</p>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            Career <span className="grad-text">Timeline</span>
          </h2>
          <p className="text-slate-400 max-w-md mx-auto">7+ years across enterprise software, agencies, and freelance</p>
        </motion.div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-7 lg:left-1/2 top-0 bottom-0 w-px tl-line opacity-25 lg:-translate-x-px" />

          <div className="space-y-12">
            {EXPERIENCE.map((exp, i) => (
              <motion.div key={exp.role}
                initial={{opacity:0,y:36}} whileInView={{opacity:1,y:0}}
                transition={{duration:0.55,delay:i*0.1}} viewport={{once:true,margin:'-40px'}}
                className={`relative flex items-start gap-6 lg:gap-0 ${i%2===0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
              >
                {/* Dot */}
                <div className="absolute left-7 lg:left-1/2 lg:-translate-x-1/2 z-10">
                  <motion.div
                    whileInView={{scale:[0,1.3,1]}} transition={{duration:0.45,delay:i*0.1}}
                    viewport={{once:true}}
                    className="w-4 h-4 rounded-full border-2 flex-shrink-0"
                    style={{
                      borderColor: exp.color,
                      backgroundColor: exp.color+'22',
                      boxShadow: `0 0 14px ${exp.color}55`,
                    }}
                  />
                </div>

                {/* Card */}
                <motion.div
                  whileHover={{scale:1.02,y:-4}}
                  className={`ml-16 lg:ml-0 lg:w-[46%] glass border border-white/[0.06] rounded-3xl p-7 card-lift ${
                    i%2===0 ? 'lg:mr-auto' : 'lg:ml-auto'
                  }`}
                >
                  {/* Top row */}
                  <div className="flex items-start justify-between gap-3 mb-4">
                    <div>
                      <span className="text-xs font-bold px-3 py-1 rounded-full mb-2 inline-block"
                        style={{backgroundColor:exp.color+'22',color:exp.color}}>
                        {exp.type}
                      </span>
                      <h3 className="text-white font-bold text-xl mt-2">{exp.role}</h3>
                      <p className="text-slate-400 text-sm mt-0.5">{exp.company}</p>
                    </div>
                    <span className="text-slate-500 text-xs font-mono flex-shrink-0 text-right leading-relaxed">{exp.period}</span>
                  </div>

                  <p className="text-slate-400 text-sm leading-relaxed mb-5">{exp.desc}</p>

                  {/* Achievements */}
                  <ul className="space-y-2 mb-5">
                    {exp.wins.map(w => (
                      <li key={w} className="flex items-start gap-2 text-sm text-slate-400">
                        <span style={{color:exp.color}} className="flex-shrink-0 mt-0.5">▸</span>
                        {w}
                      </li>
                    ))}
                  </ul>

                  {/* Tech tags */}
                  <div className="flex flex-wrap gap-1.5">
                    {exp.tech.map(t => (
                      <span key={t} className="text-xs px-2.5 py-1 rounded-full font-mono"
                        style={{
                          backgroundColor: exp.color+'14',
                          color: exp.color+'cc',
                          border: `1px solid ${exp.color}25`,
                        }}>
                        {t}
                      </span>
                    ))}
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
